import React from "react";
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { createContact } from "@/_actions/contactActions";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export const schema = yup
  .object({
    name: yup.string().required("El nombre es requerido"),
    email: yup.string().email("Invalid email").nullable(true),
    phone: yup.string().nullable(true),
    message: yup.string().nullable(true),
    utm_source: yup.string().required("UTM source is required"),
    contact_place: yup.string().required("Contact place is required"),
  })
  .test(
    "email-or-phone",
    "El teléfono o el correo electrónico son requeridos",
    function (values) {
      const { email, phone } = values || {};
      if (!email && !phone) {
        return this.createError({
          path: "email",
          message: "El teléfono o el correo electrónico son requeridos",
        });
      }
      return true;
    }
  );

const CreateContact = ({ callBack = () => {} }) => {
  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      message: "",
      utm_source: "crm",
      utm_campaign: "Pro_Crm",
      contact_place: window?.location?.hostname || "panel pro",
    },
  });

  return (
    <div>
      <Form {...form}>
        <form
          onSubmit={async (e) => {
            try {
              e.preventDefault();
              await createContact(form.getValues());
              callBack();
            } catch (error) {
              console.error("Error sending messandleSubmit(createContact)");
            }
          }}
        >
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel>Nombre</FormLabel>
                <FormControl>
                  <input {...field} type="text" placeholder="Juan Perez" />
                </FormControl>
                <FormDescription />
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel>Email</FormLabel>
                <FormControl>
                  <input
                    {...form.register("email", {
                      setValueAs: (value) => value || null,
                    })}
                    type="email"
                    placeholder="Email"
                  />
                </FormControl>
                <FormDescription />
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="phone"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel>Teléfono</FormLabel>
                <FormControl>
                  <input
                    {...form.register("phone", {
                      setValueAs: (value) => value || null,
                    })}
                    type="text"
                    placeholder="Teléfono"
                  />
                </FormControl>
                <FormDescription />
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="message"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel>Mensaje</FormLabel>
                <FormControl>
                  <textarea
                    {...form.register("message", {
                      setValueAs: (value) => value || null,
                    })}
                    placeholder="Mensaje"
                  />
                </FormControl>
                <FormDescription />
                <FormMessage />
              </FormItem>
            )}
          />
          <FormItem>
            <FormControl>
              <Button
                className="w-full"
                disabled={
                  !form.formState.isValid || form.formState.isSubmitting
                }
                type="submit"
              >
                Agregar
              </Button>
            </FormControl>
          </FormItem>
        </form>
      </Form>
    </div>
  );
};

export default CreateContact;
